import React from 'react'
import SyntaxHighlighter from 'react-syntax-highlighter'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import USBTabs from '@usb-shield/react-tabs'
import { USBIconDocuments } from '@usb-shield/react-icons'
import { v4 as uuidv4 } from 'uuid'

export const CodeBlocks = (props) => {
  const [copyText, setCopyText] = React.useState(<USBIconDocuments />)

  const codeBlocks = props.codeBlocks
  const tabTitles = []

  const handleClick = () => {
    setCopyText('Copied to Clipboard')

    setTimeout(() => {
      handleClose()
    }, 1000)
  }

  const handleClose = () => {
    setCopyText(<USBIconDocuments />)
  }

  codeBlocks.forEach((codeBlock) => {
    const language = codeBlock.props.children[0].props.className.replace(
      'language-',
      ''
    )
    tabTitles.push(language)
  })

  return (
    <div className="code-example">
      <USBTabs tabs={tabTitles}>
        {codeBlocks.map((code) => {
          const language = /language-(\w+)/.exec(
            code.props.children[0].props.className || ''
          )
          const codeLines = code.props.children[0].props.children[0]

          return (
            <Panel key={uuidv4()}>
              <SyntaxHighlighter language={language[1]} useInlineStyles={false}>
                {codeLines}
              </SyntaxHighlighter>
              <CopyToClipboard text={codeLines}>
                <button
                  aria-label="Copy code"
                  onClick={handleClick}
                  className="code-block-copy"
                >
                  {copyText} Copy to Clipboard
                </button>
              </CopyToClipboard>
            </Panel>
          )
        })}
      </USBTabs>
    </div>
  )
}

export const Panel = (props) => {
    return <React.Fragment>{props.children}</React.Fragment>;
};

export default CodeBlocks